import angular from 'angular';
import purchasingAccountsComponent from './purchasingAccounts.component';
import purchasingAccountsService from './purchasingAccounts.service';



let purchasingAccountsModule = angular.module('purchasingAccounts', [])
  .component('purchasingAccounts', purchasingAccountsComponent)
  .service('purchasingAccountsService', purchasingAccountsService);

export default purchasingAccountsModule;



// WEBPACK FOOTER //
// ./app/components/purchasingAccounts/purchasingAccounts.js